import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/admin/Sidebar';
import Topbar from '@/components/admin/Topbar';
import MobileTopbar from '@/components/admin/MobileTopbar';
import MobileBottomNav from '@/components/admin/MobileBottomNav';
import { adminMenu } from '@/components/admin/menuConfig';
import authService from '@/services/authService';
import SEO from '@/components/common/SEO';
import { prefixAdminPaths, isReservedAdminRoute } from '@/utils/adminPaths';
import { getArenaSlug, setArenaSlug } from '@/utils/arena';
import { useSidebar } from '@/contexts/SidebarContext';

interface AdminLayoutProps {
  arenaSlug?: string;
}

const AdminLayout = ({ arenaSlug }: AdminLayoutProps) => {
  const { isCollapsed } = useSidebar();
  const rawSlug = arenaSlug && !isReservedAdminRoute(arenaSlug) ? arenaSlug : authService.getSlug();
  const slug = rawSlug && !isReservedAdminRoute(rawSlug) ? rawSlug : getArenaSlug();
  if (slug && !isReservedAdminRoute(slug) && localStorage.getItem('arenaSlug') !== slug) {
    setArenaSlug(slug);
  }
  const menuWithSlug = prefixAdminPaths(adminMenu, slug);

  const filteredMenu = menuWithSlug.filter(
    (item) => !item.roles || item.roles.includes(authService.getRole() as string)
  );

  return (
    <>
      <SEO title="Sporto Admin" description="Dashboard admin Sporto" url="/admin" noIndex={true} />
      <div className="h-screen bg-[#F5F6F7] hidden md:flex overflow-hidden">
        <aside
          className={`shrink-0 h-screen bg-white border-r border-gray-200/80 transition-[width] duration-300 ease-in-out relative z-20 overflow-hidden ${
            isCollapsed ? 'w-20' : 'w-[272px]'
          }`}
        >
          <Sidebar menuItems={menuWithSlug} />
        </aside>
        <div className="flex-1 min-w-0 h-screen flex flex-col overflow-y-auto overflow-x-hidden">
          <Topbar page="admin" />
          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>

      <div className="md:hidden min-h-screen flex flex-col bg-white">
        <MobileTopbar menuItems={filteredMenu} />

        <main className="flex-1 overflow-auto pt-safe-offset-16 pb-safe-offset-20">
          <Outlet />
        </main>

        <MobileBottomNav items={filteredMenu} />
      </div>
    </>
  );
};

export default AdminLayout;
